import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=6ec0e71e&scoped=true"
import script from "./svg-icon.vue?vue&type=script&lang=js"
export * from "./svg-icon.vue?vue&type=script&lang=js"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=6ec0e71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0e71e",
  null
  
)

export default component.exports